import React, { lazy, Suspense } from "react";

//import DefaultLoader from "../utilities/loaders/DefaultLoader";

import DefaultLoader from "../../utilities/loaders/DefaultLoader";
const DepartmentManagementContent = lazy(
  () => import("./DepartmentManagementContent"),
);

const DepartmentManagement = () => {
  return (
    <Suspense fallback={<DefaultLoader />}>
      <DepartmentManagementContent />
    </Suspense>
  );
};

export default DepartmentManagement;
